import getSharingInfoRequest from 'owa-service/lib/factory/getSharingInfoRequest';
import getSharingInformationOperation from 'owa-service/lib/operation/getSharingInformationOperation';
function createRequest(attachmentUrl) {
    return getSharingInfoRequest({ attachmentUrl: attachmentUrl });
}
export default function getSharingInformation(attachmentUrl) {
    return getSharingInformationOperation(createRequest(attachmentUrl));
}
//# sourceMappingURL=getSharingInformation.js.map